import { useTranslation } from 'react-i18next'

interface Option {
  value: string
  label: string
}

interface FilterCheckboxListProps {
  options: Option[]
  value: Record<string, boolean>
  onChange: (value: Record<string, boolean>) => void
}

const FilterCheckboxList = ({
  options,
  value,
  onChange,
}: FilterCheckboxListProps) => {
  const { t } = useTranslation()

  const handleToggle = (optionValue: string) => {
    onChange({
      ...value,
      [optionValue]: !value[optionValue],
    })
  }

  return (
    <div className="flex flex-col gap-2">
      {options.map((opt) => (
        <label
          key={opt.value}
          className="flex items-center gap-2 cursor-pointer text-sm text-gray-800"
        >
          <input
            type="checkbox"
            checked={value[opt.value] ?? false}
            onChange={() => handleToggle(opt.value)}
            className="w-4 h-4 rounded border-gray-300 text-imovPrimary focus:ring-imovPrimary"
          />
          <span>{opt.label.includes('.') ? t(opt.label) : opt.label}</span>
        </label>
      ))}
    </div>
  )
}

export default FilterCheckboxList
